import axiosFlow from '@/services/axios/axiosFlow'

export default class EquipeService {
  static async get() {
    return axiosFlow.get('equipes').then(res => res.data.data)
  }

  static async getById(equipeId) {
    return axiosFlow.get(`equipes/${equipeId}`).then(res => res.data.data)
  }

  static async getEquipesDaEmpresa(empresaId) {
    return axiosFlow.get(`equipes?EmpresaId=${empresaId}`).then(res => res.data.data)
  }

  static async getAgentesAssociadosAEquipe(equipeId) {
    return axiosFlow.get(`equipes/${equipeId}/associacoes`).then(res => res.data.data)
  }

  static async getEquipesAtivas(gestorId) {
    const params = new URLSearchParams()

    params.append('Ativo', true)

    if (gestorId) {
      params.append('GestorId', gestorId)
    }

    return axiosFlow.get(`equipes?${params}`).then(res => res.data.data)
  }

  static async getEquipeAgentes(equipeId, integranteId) {
    const params = new URLSearchParams()

    if (equipeId) {
      params.append('EquipeId', equipeId)
    }
    if (integranteId) {
      params.append('IntegranteId', integranteId)
    }

    return axiosFlow.get(`equipes/agentes?${params}`).then(res => res.data.data)
  }

  static async getEquipesAgentesExternos(cargoId, departamentoId) {
    const params = new URLSearchParams()

    if (cargoId) {
      params.append('CargoId', cargoId)
    }
    if (departamentoId) {
      params.append('DepartamentoId', departamentoId)
    }

    return axiosFlow.get(`equipes/agentes-externos?${params}`).then(res => res.data.data)
  }

  static async getAgentesNaoAssociados(equipeId) {
    const params = new URLSearchParams()

    params.append('Associados', false)

    return axiosFlow.get(`equipes/${equipeId}/colaboradores?${params}`).then(res => res.data.data)
  }

  static async getIntegrantes(nome, email) {
    const params = new URLSearchParams()

    if (nome) {
      params.append('Nome', nome)
    }
    if (email) {
      params.append('Email', email)
    }

    return axiosFlow.get(`equipes/integrantes?${params}`)
  }

  static async criar(body) {
    return axiosFlow.post('equipes', body)
  }

  static async atualizar(equipeId, body) {
    return axiosFlow.put(`equipes/${equipeId}`, body)
  }

  static async associarEquipeEAgente(equipeId, data) {
    return axiosFlow.post(`equipes/${equipeId}/colaborador`, data)
  }

  static async deleteEquipeIntegrante(equipeId, integranteId) {
    return axiosFlow.delete(`equipes/${equipeId}/integrante/${integranteId}`)
  }

  static async confirmarAtivacaoOuInativacao(equipeId, body) {
    return axiosFlow.put(`equipes/${equipeId}/ativada`, body)
  }
}
